module.exports = __webpack_public_path__ + "static/media/ic_cancel_meeting.42d8b09f.svg";